import { render, staticRenderFns } from "./TransportEdit.vue?vue&type=template&id=96c136a4&"
import script from "./TransportEdit.vue?vue&type=script&lang=js&"
export * from "./TransportEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports